<template>
  <div>
    <a
      class="inline-block"
      :class="{'opaque-70 cursor-not-allowed': disable, 'cursor-pointer': !disable && clickable, 'text-clickable basic-link': clickable}"
      @click="!disable && clickable ? $emit('click') : null"
    >
      <q-icon
        v-if="icon"
        :name="icon"
        size="1em"
        class="relative-position q-mr-xs"
        style="bottom: 1px;"
      />
      <slot />
    </a>
  </div>
</template>

<script>
/**
 * A basic href element for clicking elements
 *
 * EVENTS:
 * - click: when element is clicked
 */
export default {
  props: {
    clickable: {
      type: Boolean,
      default: true
    },
    // Disable clicking
    disable: {
      type: Boolean,
      default: false
    },
    // Icon to display on left of text
    icon: {
      type: String,
      default: null
    }
  },
  emits: ['click']
}
</script>
